import type React from 'react';
import { useTranslation } from 'react-i18next';
import type {
  ConversationMessageDataType,
  ConversationUserType,
} from '../../../../redux/ducks/ChatDucks.types';
import AppointmentSummaryBlock from './AppointmentSummaryBlock';

export type AppointmentCancelDeniedMessageProps = {
  data: ConversationMessageDataType;
  user?: ConversationUserType;
  mine?: boolean;
  iamprovider: boolean;
};

const AppointmentCancelDeniedMessage: React.FC<
  AppointmentCancelDeniedMessageProps
> = ({ data, user, mine }) => {
  const { t } = useTranslation();
  const meta = data?.meta;

  if (!meta) {
    return null;
  }

  return (
    <div className="flex min-w-full flex-col items-center justify-center">
      <div>
        <span className="mb-4 flex min-w-full flex-row items-center justify-center text-center text-base font-bold">
          {mine
            ? t('static.chat.message_header_appointment_cancel_denied_mine', {
                name: `${user?.first_name} ${user?.last_name}`,
              })
            : t('static.chat.message_header_appointment_cancel_denied_other', {
                name: `${user?.first_name} ${user?.last_name}`,
              })}
        </span>
        <AppointmentSummaryBlock data={data} />
      </div>
    </div>
  );
};

export default AppointmentCancelDeniedMessage;
